import * as S from './styles';
import { CheckImage } from './styles';
import { DescriptionWrap } from './styles';
import { Description } from './styles';

interface PlanSolution {
  label: string;
  value: string | boolean; // 텍스트 or 체크표시
}

const PcPlan = () => {
  const baseImageUrl = process.env.NEXT_PUBLIC_BASE_IMAGE_URL;
  const planSolutionList: PlanSolution[] = [
    { label: '수집 대상 채널', value: '기본 채널 + 수집 대상 채널 추가 \n(네이버 카페 / 네이버 블로그 / 강남언니 / 바비톡 등)' },
    { label: '리뷰 통합 대시보드', value: '전체보기' },
    { label: '리뷰 수집 알림', value: true },
    { label: 'AI 리뷰 점수 분석', value: true },
    { label: 'AI 리뷰 키워드 분석', value: true },
    { label: 'AI 리뷰 추천 답변 제공', value: '병원 커스텀 말투 설정' },
    { label: 'AI 추천 답변 자동 등록', value: true }
  ];
  return (
    <S.Container>
      <S.Inner>
        <S.Section>
          <S.Title>Enterprise Plan</S.Title>
          <S.SubTitle>리뷰 탐지와 대응, 분석 전 과정의 솔루션 </S.SubTitle>
          <S.SolutionList>
            {planSolutionList.map((solution, index) => {
              return (
                <S.Solution key={`enterprise-solution-section01-${index}`}>
                  <S.Label>{solution.label}</S.Label>
                  {typeof solution.value === 'boolean' ? (
                    <S.CheckValue>
                      <S.CheckImage src={`${baseImageUrl}/icons/check.svg`} alt={'체크'} width={16} height={16} />
                    </S.CheckValue>
                  ) : (
                    <S.Value>{solution.value}</S.Value>
                  )}
                </S.Solution>
              );
            })}
          </S.SolutionList>
        </S.Section>
        <S.Section>
          <S.SolutionList>
            <S.Solution>
              <S.Label>플랫폼 삭제 요청 업무 대행</S.Label>
              <S.Value>매월 10건 무료</S.Value>
            </S.Solution>
            <S.Solution>
              <S.Label>방심위 삭제 요청 업무 대행</S.Label>
              <S.Value>30만원 / 건</S.Value>
            </S.Solution>
          </S.SolutionList>
          <S.DescriptionWrap>
            <S.Description>
              악성 리뷰에 대해 네이버 등 플랫폼에 권리 침해 신고 (게시 중단 요청)을 대행합니다. 직접 신청 대비 대폭 향상된 확률(95% 이상)로 게시 중단을 달성할 수 있습니다.{' '}
            </S.Description>
            <S.Description>게시자 이의 제기로 게시 중단 실패된 경우, 방송통신심의위원회에 직접 게시 중단을 요청합니다. </S.Description>
          </S.DescriptionWrap>
        </S.Section>
        <S.Section>
          <S.Solution>
            <S.Label>고객 리뷰 대응 서비스</S.Label>
            <S.Value>병원 채널에 작성된 고객 리뷰에 대한 답변 작성을 대행 (24시간 이내)</S.Value>
          </S.Solution>
          <S.Solution>
            <S.Label>악성 리뷰 대응 서비스</S.Label>
            <S.Value>매출 감소 리스크 최소화를 위한 컨설팅 (사전 위임 시 즉각 대응 실행)</S.Value>
          </S.Solution>
          <S.Solution>
            <S.Label>인사이트 리포트 </S.Label>
            <S.Value>리뷰 현황 및 고객 인사이트 리포트 제공</S.Value>
          </S.Solution>
        </S.Section>
      </S.Inner>
    </S.Container>
  );
};

export default PcPlan;
